import './deviceList.css'
import {foucsOnElement} from '../../utils/focusOnElement'
import {useDispatch, useSelector} from '../../store'
import {For, createEffect, createSignal, onMount} from 'solid-js'
import {useIcon} from '../icon/useIcon'
import {FocusGroupProvider, FocusableProvider} from '../focus/index'
import {useSpatialNavigation} from '../../spatialNavigation'
import {deleteBackendDevice, authenticate, pushNotification} from '@te_react/volt-store/lib/actions'
import {getDeviceData, isWeb} from '../../utils'
import {useI18n} from '../../i18n'
import {useConfig} from '../config/useConfig'
const DeviceList = (props: any) => {
    const icons = useIcon()
    const dispatch = useDispatch()
    const {getI18n} = useI18n()
    const {getConfig} = useConfig()
    const locale = useSelector((state: any) => state?.language?.locale)
    const {setFocus, navigateByDirection} = useSpatialNavigation()
    const [selectedDevice, setSelectedDevice] = createSignal<any>({})

    const CheckMark = icons.get('CheckSolo')

    onMount(() => {
        setFocus('device-list-item' + props.deviceList.deviceList[0]?.id)
    })

    const handleTvLogin = (username: string, password: string) => {
        const deviceData = getDeviceData()
        const deviceid = isWeb ? 1 : 3

        dispatch(
            authenticate({
                loginType: props.voltApi.Constants.loginType.USERNAME_AND_PASSWORD,
                username,
                password,
                deviceData: {
                    ...deviceData,
                    deviceId: deviceid,
                },
            })
        )
    }

    const onClickRemove = () => {
        if (Object.keys(selectedDevice()).length > 0) {
            props.setIsSubmittingOoredoo(true)
            props.setShowNewLoginForm(false)
            props.setShowNewLoginOtp(false)
            dispatch(deleteBackendDevice({device: selectedDevice(), username: localStorage.getItem('USER_ID'), 
                onSuccess: () => {
                    props.setIsSubmittingOoredoo(false)
                    props.setShowNewLoginForm(false)
                    props.setShowNewLoginOtp(false)
                    handleTvLogin(localStorage.getItem('USER_ID') || '', '1111')
                },
                onFailed: () => {
                    props.setIsSubmittingOoredoo(false)
                    props.setShowNewLoginForm(false)
                    props.setShowNewLoginOtp(true)
                }
            }))
        }
        else {
            dispatch(pushNotification({
                message: {
                    tag: getI18n()?.formatMessage({id: 'PROCEED_DEVICE_ERROR'}),
                    type: "information",
                },
            }),)
        }
    }

    const formatDate = (timestamp: any) => {
        const date = new Date(timestamp)
        const yyyy = date.getFullYear()
        const month = date.getMonth() + 1 // Months start at 0!
        const mm = month < 10 ? '0' + month : month
        const dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

        return dd + '/' + mm + '/' + yyyy
    }

    const getDeviceName = (device: any) => {
        return device?.name?.includes("Tizen") || device?.name?.includes("WebOS") ? device?.name.replace("Mozilla", "Smart TV") : device?.name
    }

    const handleDeviceListWheel = (e: WheelEvent) => {
        const wheelDelta = e.deltaY
        // deltaY on one spike for LG remote is 53 as observed so added condition to 50
        if (Math.abs(wheelDelta) <= 50) return

        const direction = wheelDelta > 0 ? 'down' : 'up';
        navigateByDirection(direction, {})
    }

    return (
       
        <div 
        class={`${getConfig().rtlLanguages.includes(locale()) ? 'devicePopUpContainer rtl' : 'devicePopUpContainer ltr'}`} 
        style={{
            direction: `${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`
        }}
        >
            <div class="deviceManagement">{getI18n()?.formatMessage({id: 'DEVICE_LIMIT_REACHED'})}</div>
            <div class="description">{getI18n()?.formatMessage({id: 'SOLO_DEVICE_DESCRIPTION'})}</div>
            <div class="grid-container-header" style={{'margin-bottom': '10px'}}>
                <div class="grid-item-header">{getI18n()?.formatMessage({id: 'LAST_LOGIN'})}</div>
                <div class="grid-item-header" style={{'margin-left': getConfig().rtlLanguages.includes(locale())?'0px':'126px'}}>
                    {getI18n()?.formatMessage({id: 'LIST_OF_DEVICES'})}
                </div>
                <div class="grid-item-header" style={{'margin-left': getConfig().rtlLanguages.includes(locale()) ? '120px' :'219px'}}>
                    {props.deviceList.deviceList.length}/1
                </div>
            </div>

            <FocusGroupProvider
                focusKey="device-list-container"
                class="device-list-container"
                saveLastFocusedChild={true}
            >
                <div class="grid-container"  onWheel={handleDeviceListWheel}>
                    <For each={props.deviceList.deviceList}>
                        {device => {
                            return (
                                <>
                                    <div class="grid-item-date for-dates">{formatDate(device?.lastLoginTime)}</div>

                                    <FocusableProvider
                                        id={'device-list-item' + device.id}
                                        focusKey={'device-list-item' + device.id}
                                        onFocus={() => {
                                            foucsOnElement(document.getElementById(`device-list-item${device.id}`))
                                        }}
                                        onEnterPress={() => {
                                            setSelectedDevice(device)
                                            setFocus('proceed-device')
                                        }}
                                        class="grid-item-name for-name"
                                    >
                                        {(focused: any) => {
                                            return (
                                                <div
                                                    class={`device-list-item ${focused?.() ? 'focused-container ' : 'un-focused-container'}`}
                                                    onClick={() => {
                                                        setSelectedDevice(device)
                                                        setFocus('proceed-device')
                                                    }}
                                                >
                                                    <div>
                                                        {getDeviceName(device)?.length > 20
                                                            ? getDeviceName(device)?.substring(0, 20) + '...'
                                                            : getDeviceName(device)}
                                                    </div>
                                                    {selectedDevice()?.id === device.id && <CheckMark />}
                                                </div>
                                            )
                                        }}
                                    </FocusableProvider>
                                    <div class="empty-div"></div>
                                </>
                            )
                        }}
                    </For>
                </div>
            </FocusGroupProvider>
            <FocusGroupProvider focusKey="device-button-container" id="device-button-container">
                <div class="device-list-button-container">
                    <FocusableProvider
                        id={'back-button'}
                        focusKey={`back-button`}
                        onEnterPress={() => {
                            props.setShowDeviceList(false)
                            props.resetStates()
                        }}
                    >
                        {(focused: any) => (
                            <button
                                id="back-button"
                                class={`login-content-button-tv-new ${focused?.() ? 'login-content-button-tv-new-focus' : ''}`}
                                type="submit"
                                onClick={() => {
                                    props.setShowDeviceList(false)
                                    props.resetStates()
                                }}
                            >
                                {getI18n()?.formatMessage({id: 'EXIT'})}
                            </button>
                        )}
                    </FocusableProvider>
                    <FocusableProvider
                        id={'proceed-device'}
                        focusKey={`proceed-device`}
                        onEnterPress={() => {
                            onClickRemove()
                        }}
                    >
                        {(focused: any) => (
                            <button
                                class={`login-content-button-tv-new ${focused?.() ? 'login-content-button-tv-new-focus' : ''}`}
                                onClick={() => onClickRemove()}
                            >
                                {getI18n()?.formatMessage({id: 'PROCEED'})}
                            </button>
                        )}
                    </FocusableProvider>
                </div>
            </FocusGroupProvider>
        </div>
    )
}

export default DeviceList
